import React, { Suspense } from 'react'

import Field from '../../../../components/fields'
import { SectionHeader } from '../../../../components/generic'

export default function FamilyLogViewSettings(props) {
  const { formId, homeSettings } = props

  return (
    <div style={styles.sectionContainer}>
      <SectionHeader title={ITEMS_TITLE} greyLine compact />
      <p>
        {ITEMS_SUBTITLE}
        <br />
        <br />
        <strong>Note: </strong>
        {ITEMS_NOTE}
      </p>
      <div style={{ paddingTop: 12 }}>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          formId={formId}
          keys="familyLogCategoryItems"
          displayLabel={false}
          type="logCategoryItems"
          values={homeSettings}
        />
        </Suspense>
      </div>
    </div>
  )
}

const ITEMS_TITLE = 'Family Portal Logs'
const ITEMS_SUBTITLE =
  'If you would like to customise the logs that families can see whilst using the app, you can toggle them on and off here. Remember, these changes will be applied to all of the members that are using the App for your service.'
const ITEMS_NOTE = 'Family members cannot see custom logs'

const styles = {
  sectionContainer: {
    marginTop: 35,
    marginBottom: 15,
    width: '100%',
  },
  featureOptionsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 8,
  },
}
